import React from 'react'
import { Box, TextField } from '@mui/material'

const DatePicker = ({ startDate, endDate, setStartDate, setEndDate }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <TextField
        type={'date'}
        value={startDate}
        label='Start date'
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ mr: 1 }}
      ></TextField>
      <TextField
        type={'date'}
        value={endDate}
        label='End date'
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
      ></TextField>
    </Box>
  )
}

export default DatePicker
